export const TOP_SLIDER_IMAGES = [
  '/images/top/top1.webp',
  '/images/top/top2.webp',
  '/images/top/top3.webp',
  '/images/top/top4.webp',
  '/images/top/top5.webp',
] as const;

// 各スライダー画像に対応する記事へのリンク
export const TOP_SLIDER_LINKS = [
  '/article/sky-express-airline-review',
  '/article/',
  '/article/',
  '/article/',
  '/article/',
] as const; 
